export default __webpack_public_path__ + "static/media/dotsHC.535e9c9c.svg";